var React = require('react');

function BuiltWithAiCtaArrowPink (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M20.9225 1.3131L29.6006 9.99122C30.1331 10.5238 30.1331 11.3872 29.6006 11.9197L20.9225 20.5978C20.3899 21.1304 19.5265 21.1304 18.994 20.5978C18.4615 20.0653 18.4615 19.2019 18.994 18.6694L25.3443 12.3191H1.36364C0.610521 12.3191 0 11.7086 0 10.9555C0 10.2023 0.610521 9.59183 1.36364 9.59183H25.3443L18.994 3.24157C18.4615 2.70904 18.4615 1.84563 18.994 1.3131C19.5265 0.780563 20.3899 0.780563 20.9225 1.3131Z","fill":"#E60A5A"}));
}

BuiltWithAiCtaArrowPink.defaultProps = {"width":"30","height":"21","viewBox":"0 0 30 21","fill":"none"};

module.exports = BuiltWithAiCtaArrowPink;

BuiltWithAiCtaArrowPink.default = BuiltWithAiCtaArrowPink;
